export default {
      id: "remove-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#remove-usage",
      toString: function () {
        return this.url;
      }
    }